import React, { memo, useMemo } from 'react'
import { Link } from 'gatsby'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { ChevronDown } from 'lucide-react'
import { contentItems } from '../../data/menu'

const Menu = () => {
  const renderMenuItems = useMemo(
    () => items => (
      <ul className="m-0 grid gap-3 p-1 md:w-[400px] lg:w-[500px] lg:grid-cols-[.75fr_1fr]">
        {items.map(item => (
          <DropdownMenuItem key={item.title} asChild>
            {item.isExternal ? (
              <a
                className="flex h-full w-full select-none flex-col justify-start rounded-md bg-gradient-to-b from-muted/50 to-muted p-4 no-underline outline-none transition-colors duration-300 hover:bg-neutral-600 focus:shadow-md"
                href={item.path}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="text-lg font-bold uppercase leading-tight">
                  {item.title}
                </div>
                <p className="text-sm text-muted-foreground">
                  {item.description}
                </p>
              </a>
            ) : (
              <Link
                className="flex h-full w-full select-none flex-col justify-start rounded-md bg-gradient-to-b from-muted/50 to-muted p-4 no-underline outline-none transition-colors duration-300 hover:bg-neutral-600 focus:shadow-md"
                to={item.path}
              >
                <div className="text-lg font-bold uppercase leading-tight">
                  {item.title}
                </div>
                <p className="text-sm text-muted-foreground">
                  {item.description}
                </p>
              </Link>
            )}
          </DropdownMenuItem>
        ))}
      </ul>
    ),
    [],
  )

  return (
    <div className="m-0 flex items-center gap-2">
      <Link
        to="/fdvlive/"
        getProps={({ isPartiallyCurrent }) => ({
          className: `menu flex h-10 items-center gap-2 rounded-md px-4 py-2 text-sm font-medium text-white hover:bg-neutral-800 hover:text-neutral-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange md:text-base ${
            isPartiallyCurrent ? 'bg-neutral-800' : 'bg-neutral-800/70'
          }`,
        })}
      >
        <span>Студия ФДВ Live</span>
        <span className="h-2 w-2 animate-pulse rounded-full bg-red-500" />
      </Link>

      {/* Контент Menu Item */}
      <DropdownMenu>
        <DropdownMenuTrigger className="menu data-[state=open]:text-orange-400 flex h-10 items-center gap-1 rounded-md bg-neutral-800/70 px-4 py-2 text-sm font-medium text-white hover:bg-neutral-800 hover:text-neutral-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange data-[active]:bg-neutral-800 data-[state=open]:bg-neutral-800 md:text-base">
          <span>Контент</span>
          <ChevronDown className="h-4 w-4" />
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-auto rounded-md border-neutral-800 bg-neutral-950 shadow-lg">
          {renderMenuItems(contentItems)}
        </DropdownMenuContent>
      </DropdownMenu>

      {/* Формула 1 Menu Item */}
      {/* <DropdownMenu>
        <DropdownMenuTrigger className="menu flex h-10 items-center gap-1 rounded-md data-[state=open]:text-orange-400 bg-neutral-800/70 px-4 py-2 text-sm font-medium text-white hover:bg-neutral-800 hover:text-neutral-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange data-[active]:bg-neutral-800 data-[state=open]:bg-neutral-800 md:text-base">
          <span>Формула 1</span>
          <ChevronDown className="h-4 w-4" />
        </DropdownMenuTrigger>
        <DropdownMenuContent className="rounded-md bg-neutral-950 shadow-lg w-auto border-neutral-800">
          {renderMenuItems(formulaItems)}
        </DropdownMenuContent>
      </DropdownMenu> */}

      {/* Сообщество Menu Item */}
      {/* <Link
        to="/contacts/"
        getProps={({ isCurrent }) => ({
          className: `menu flex h-10 items-center gap-2 rounded-md px-4 py-2 text-sm font-medium text-white hover:bg-neutral-800 hover:text-neutral-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange md:text-base ${
            isCurrent ? 'bg-neutral-800' : 'bg-neutral-800/70'
          }`,
        })}
      >
        <span>Контакты</span>
      </Link> */}
    </div>
  )
}

export default memo(Menu)
